<div class="public-auth-cta" [ngClass]="{'public-auth-cta--compact': compact}">
  <div class="public-auth-cta__copy">
    <strong>{{ 'shared.public_auth_cta.title' | translate }}</strong>
    <span>{{ 'shared.public_auth_cta.description' | translate }}</span>
  </div>

  <div class="public-auth-cta__actions">
    <button
      pButton
      type="button"
      class="p-button-sm p-button-rounded"
      (click)="goToLogin()"
      [label]="'auth.login.button.sign_in' | translate"
    ></button>
    <button
      pButton
      type="button"
      class="p-button-sm p-button-rounded p-button-outlined"
      (click)="goToRegister()"
      [label]="'auth.registration.button.register' | translate"
    ></button>
  </div>
</div>
